import React from 'react';
import LoadingIndicator from 'client/components/LoadingIndicator';
import styled, { css } from 'styled-components';
import media from 'client/styles/media';
import { PageColumn, Container } from 'client/components/layout';

const AppBodyContainer = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.color.contentBackground};

  ${media.sm} {
    background: unset;
  }

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
`;

const PageContainer = ({ children }: { children: React.ReactNode }) => (
  <AppBodyContainer>
    <Container>
      <PageColumn>{children} </PageColumn>
    </Container>
  </AppBodyContainer>
);

const PageFullWidthContainer = ({ children }: { children: React.ReactNode }) => (
  <AppBodyContainer fullWidth>
    <Container fullWidth>
      <PageColumn fullWidth>{children}</PageColumn>
    </Container>
  </AppBodyContainer>
);

const PageLoadingIndicator = ({ pastDelay, error }: { pastDelay: boolean; error: Error }) => (
  <>
    {pastDelay && !error && (
      <div style={{ textAlign: 'center', paddingTop: '200px' }}>
        <LoadingIndicator />
      </div>
    )}
    {error && (
      <>
        <div style={{ textAlign: 'center', paddingTop: '200px' }}>
          <i className="fa fa-ship" style={{ fontSize: '24px' }} />
          <p>
            We shipped some changes while you were away.
            <br />
            Please refresh the page to get the latest bits.
          </p>
        </div>
      </>
    )}
    {error && console.error('Failed to load dynamic import', error)}
  </>
);

export { AppBodyContainer, PageContainer, PageFullWidthContainer, PageLoadingIndicator };
